import Header from '../Header';
import Footer from '../Footer';
import NovinkyComponent from '../NovinkyComponent';


const Novinky = () => {
    return (
        <div>
            <Header />
            <NovinkyComponent />
            <Footer/>
        </div >
    );
}

export default Novinky;